import { createAction } from "@reduxjs/toolkit";

import * as types from "../../constants/actionTypes";
import { IBlessedTemplate, Replaceable, TopologyType } from "../../constants/types";
import { IEnvironment } from "../../utils/environment";

export const fetchTopologyTypes = (environments: IEnvironment[]) => ({
  type: types.FETCH_TOPOLOGY_TYPES_REQUESTED,
  environments,
});

export const fetchCloudTypesDefaultClassic = (environment: IEnvironment) => ({
  type: types.FETCH_CLOUD_TYPES_DEFAULT_CLASSIC_REQUESTED,
  environment,
});

export const checkoutTopology = (
  topologyName: string,
  owner: string,
  topologyType: TopologyType,
  buildNumber: string,
  environment: IEnvironment,
) => ({
  type: types.CHECKOUT_REQUESTED,
  topologyName,
  owner,
  topologyType,
  buildNumber,
  environment,
});

export const updateReplaceable = (name: string, value: string) => ({
  type: types.UPDATE_REPLACEABLE,
  name,
  value,
});

export type IDeployTopologyTypeArgs = {
  Name: string;
  Owner: string;
  TopologyType: TopologyType;
  UserData: Replaceable[];
};

export const deployTopologyTypeWithQueue = (args: any, environment: IEnvironment) => ({
  type: types.DEPLOY_TOPOLOGY_TYPE_WITH_QUEUE_REQUESTED,
  args,
  environment,
});

export const uploadTemplate = (
  partnerId: number,
  user: string,
  fileName: string,
  fileContent: string,
  environment: IEnvironment,
) => ({
  type: types.UPLOAD_TEMPLATE_REQUESTED,
  partnerId,
  user,
  fileName,
  fileContent,
  environment,
});

export const uploadTemplateSuccess = createAction(
  "newTopology/uploadTemplateSuccess",
  function prepare(template: IBlessedTemplate, partnerId: number, environment: IEnvironment) {
    return {
      payload: {
        template,
        partnerId,
        environment,
      },
    };
  },
);

export const uploadTemplateForLookupFile = (
  partnerId: number,
  user: string,
  fileName: string,
  fileContent: string,
  environment: IEnvironment,
) => ({
  type: types.UPLOAD_TEMPLATE_FOR_LOOKUP_FILE_REQUESTED,
  partnerId,
  user,
  fileName,
  fileContent,
  environment,
});

export const uploadLookupFile = (
  partnerId: number,
  user: string,
  fileName: string,
  fileContent: string,
  templateUri: string,
  environment: IEnvironment,
) => ({
  type: types.UPLOAD_LOOKUPFILE_REQUESTED,
  partnerId,
  user,
  fileName,
  fileContent,
  templateUri,
  environment,
});

export const uploadLookupFileSuccess = createAction(
  "newTopology/uploadLookupFileSuccess",
  function prepare(template: IBlessedTemplate, partnerId: number, environment: IEnvironment) {
    return {
      payload: {
        template,
        partnerId,
        environment,
      },
    };
  },
);

export const resetTemplateForLookupFile = () => ({
  type: types.RESET_TEMPLATE_FOR_LOOKUP_FILE,
});

export const closeCreatePrivateTopology = () => ({
  type: types.CLOSE_CREATE_PRIVATE_TOPOLOGY,
});

export const deployPrivateTemplate = (
  topologyName: string,
  owner: string,
  path: string,
  userData: Replaceable[],
  environment: IEnvironment,
) => ({
  type: types.DEPLOY_PRIVATE_TEMPLATE_REQUESTED,
  topologyName,
  owner,
  path,
  userData,
  environment,
});

export type IDeployLookupTopologyTypeArgs = {
  Name: string;
  Owner: string;
  LookupTopologyType: TopologyType;
  UserData: Replaceable[];
};

export const deployLookupTopologyType = (
  topologyTypeArgs: IDeployLookupTopologyTypeArgs,
  environment: IEnvironment,
) => ({
  type: types.DEPLOY_LOOKUP_TOPOLOGY_TYPE_REQUESTED,
  topologyTypeArgs,
  environment,
});

export const getDuplicateThresholdTopologies = (environment: IEnvironment) => ({
  type: types.FETCH_DUPLICATE_THRESHOLD_TOPOLOGY_NAMES_REQUESTED,
  environment,
});

export const getUserRegion = (environment: IEnvironment) => ({
  type: types.GET_USER_REGION_REQUESTED,
  environment,
});
